export function convertToDecimalCoordinates(latitude: string, longitude: string) {
  if (latitude === '' || latitude === undefined || longitude === '' || longitude === undefined) {
    return;
  }

  let lat = parseFloat(latitude);
  let lng = parseFloat(longitude);

  // Check if the coordinates are in the Southern Hemisphere and, if so, add a minus sign
  if (latitude.toUpperCase().endsWith('S')) {
    lat = -latitude;
  }

  // Check if the coordinates are in the Western Hemisphere and, if so, add a minus sign
  if (longitude.toUpperCase().endsWith('W')) {
    lng = -longitude;
  }

  return { lat, lng };
}
